import { collectEvents } from 'clients/MonitorClient';
import { debounce } from 'utils/function';

export type EventType = 'onMouseMove' | 'onClick';

const RESET_TIME = 60000;
const WAITING_TIME_SEND_API = 500;

interface Props {
  getItemParamTracking: (
    event: React.MouseEvent<HTMLDivElement>,
    eventType: EventType,
  ) => {
    body: any;
    eventKey: string;
  };
}

export const useEventTracking = ({ getItemParamTracking }: Props) => {
  let bodyList: any[] = [];

  const hovered: any = [];
  const clicked: any = [];

  const sendEventsToApi = debounce((events) => {
    collectEvents(events);
    bodyList = [];
  }, WAITING_TIME_SEND_API);

  const flushEvents = () => {
    if (bodyList.length > 0) {
      sendEventsToApi(bodyList);
    }
  };

  const onListenerEvent = (event: React.MouseEvent<HTMLDivElement>, type: EventType) => {
    const paramTracking = getItemParamTracking(event, type);
    const { body, eventKey } = paramTracking;

    if (!Object.keys(body).length || !eventKey) return;

    const bodyString = JSON.stringify(paramTracking);

    if (type === 'onMouseMove') {
      const item = hovered.find((item: any) => item.value === bodyString);

      if (!item) {
        hovered.push({ value: bodyString, time: new Date() });
        bodyList.push({ metadata: body, event: eventKey });
      } else if (item.time && new Date().getTime() - new Date(item.time).getTime() > RESET_TIME) {
        item.time = new Date();
        bodyList.push({ metadata: body, event: eventKey });
      }
    }

    if (type === 'onClick') {
      const item = clicked.find((item: any) => item.value === bodyString);
      if (!item) {
        clicked.push({ value: bodyString, time: new Date() });
        bodyList.push({ metadata: body, event: eventKey });
      } else if (item.time && new Date().getTime() - new Date(item.time).getTime() > RESET_TIME) {
        item.time = new Date();
        bodyList.push({ metadata: body, event: eventKey });
      }
    }

    flushEvents();
  };

  const onMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!getItemParamTracking) return;

    onListenerEvent(event, 'onMouseMove');
  };

  const onClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!getItemParamTracking) return;

    onListenerEvent(event, 'onClick');
  };

  return {
    onMouseMove,
    onClick,
  };
};

